// import React, { useState, useEffect } from "react";
// import { FaTrashAlt } from "react-icons/fa";
// import { MdInfoOutline } from "react-icons/md";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";


// const StackedChart_FilterPopup = ({
//     show,
//     onClose,
//     onApply,
//     mainpayload,
//     selectedItems,
//     setSelectedItems,
//     workspace_locations = [],
//     fetchLocations,
// }) => {
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedListType, setSelectedListType] = useState("workspace");
//     const [drillStack, setDrillStack] = useState([
//         { label: "India", value: 1000, geo_level: 1 },
//     ]);
//     const [currentList, setCurrentList] = useState([]);

//     // 🧩 Convert mainpayload.lgd_codes → usable list format
//     const mainFormattedPayload = (mainpayload?.lgd_codes || []).map((item) => ({
//         name: item.code === 1000 && item.geo_level_code === 1 ? "India" : item.name || `Code ${item.code}`,
//         lgd_code: item.code,
//         geo_level: item.geo_level_code,
//     }));

//     // 🟢 Initial setup — add “India” if code 1000 with geo_level 1 exists
//     useEffect(() => {
//         const hasIndia =
//             mainpayload?.lgd_codes?.some(
//                 (p) => p.code === 1000 && p.geo_level_code === 1
//             ) || false;

//         setSelectedItems((prev) => {
//             let updated = [...prev];
//             if (hasIndia && !updated.some((p) => p.lgd_code === 1000)) {
//                 updated.push({ name: "India", lgd_code: 1000, geo_level: 1 });
//             }

//             // Add all items from mainpayload initially (for “All Selected”)
//             mainFormattedPayload.forEach((item) => {
//                 if (!updated.some((p) => p.lgd_code === item.lgd_code)) {
//                     updated.push(item);
//                 }
//             });
//             return updated;
//         });
//     }, [mainpayload]);
//     // 🧭 Fetch locations when drilling down
//     useEffect(() => {
//         const load = async () => {
//             const top = drillStack[drillStack.length - 1];
//             const parentCode = top.value === null ? 1000 : top.value;
//             const nextLevel = top.geo_level;
//             const children = await fetchLocations(parentCode, nextLevel);
//             const mapped = (children || []).map((loc) => ({
//                 name: loc.name || loc.label,
//                 lgd_code: loc.code || loc.id || loc.value || loc.lgd_code || loc.properties?.code,
//                 geo_level: loc.geo_level || loc.geo_level_code || loc.properties?.geo_level || nextLevel,
//             }));
//             setCurrentList(mapped);
//         };
//         if (selectedListType === "all") load();
//     }, [drillStack, selectedListType, fetchLocations]);

//     const handleApply = () => {
//         onApply(selectedItems, mainpayload);
//         onClose();
//     };


//     const addListOfItem = (item) => {
//         setSelectedItems((prev) => {
//             const exists = prev.some((p) => p.lgd_code === item.lgd_code);
//             if (!exists) return [...prev, item];
//             return prev;
//         });
//     };

//     const removeItem = (item) => {
//         setSelectedItems((prev) =>
//             prev.filter((p) => p.lgd_code !== item.lgd_code)
//         );
//     };

//     // 🟦 Workspace = from mainFormattedPayload (or workspace_locations)
//     const getWorkspaceList = () => {
//         if (workspace_locations.length > 0) {
//             return workspace_locations.map((loc) => ({
//                 name: loc.name || loc.label,
//                 lgd_code: loc.code || loc.id || loc.value || loc.lgd_code || loc.properties?.code,
//                 geo_level: loc.geo_level || loc.geo_level_code || loc.properties?.geo_level,
//             }));
//         }
//         return mainFormattedPayload;
//     };

//     const getSelectedList = () => {
//         const map = new Map();
//         selectedItems.forEach((it) => map.set(it.lgd_code, it));
//         return Array.from(map.values());
//     };

//     const filterBySearch = (arr) =>
//         arr.filter((x) =>
//             x.name?.toLowerCase().includes(searchTerm.toLowerCase())
//         );

//     const getDisplayed = () => {
//         if (selectedListType === "workspace") return filterBySearch(getWorkspaceList());
//         if (selectedListType === "all") return filterBySearch(currentList);
//         if (selectedListType === "selected") return filterBySearch(getSelectedList());
//         return [];
//     };

//     const displayed = getDisplayed();

//     const goDrillDown = (loc) => {
//         setDrillStack((prev) => [
//             ...prev,
//             { label: loc.name || loc.label, value: loc.lgd_code, geo_level: loc.geo_level },
//         ]);
//     };

//     const goBackUp = () => {
//         if (drillStack.length > 1)
//             setDrillStack((prev) => prev.slice(0, -1));
//     };

//     return (
//         show && (
//             <div
//                 className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
//                 style={{ background: "rgba(0,0,0,0.5)", zIndex: 1050 }}
//             >
//                 <div
//                     className="bg-white p-4 rounded shadow"
//                     style={{ width: "600px", maxHeight: "80vh", overflowY: "auto", position: "relative" }}
//                 >
//                     <button className="btn-close position-absolute top-0 end-0 m-3" onClick={onClose} />

//                     <h5 className="fw-bold mb-3 d-flex align-items-center gap-2">
//                         Filters <OverlayTrigger
//                             placement="right"
//                             overlay={
//                                 <Tooltip id="filter-tooltip">
//                                     <ol className="mb-0 ps-3">
//                                         <li>Add with “+”, remove in “All Selected” tab.</li>
//                                         <li>“Show All Children” expands deeper levels (geo level &lt; 4).</li>
//                                         <li>Already added items are disabled.</li>
//                                     </ol>
//                                 </Tooltip>
//                             }
//                         >
//                             <span>
//                                 <MdInfoOutline style={{ cursor: "pointer", color: "#000000" }} />
//                             </span>
//                         </OverlayTrigger>
//                     </h5>

//                     <div className="d-flex justify-content-between align-items-center mb-3 w-100">
//                         {/* Tabs on the left */}
//                         <div className="btn-group pt-2" role="group" aria-label="Filter tabs">
//                             <input
//                                 type="radio"
//                                 className="btn-check"
//                                 name="filter-tabs"
//                                 id="workspace-tab"
//                                 autoComplete="off"
//                                 checked={selectedListType === "workspace"}
//                                 onChange={() => setSelectedListType("workspace")}
//                             />
//                             <label className="btn btn-outline-primary" htmlFor="workspace-tab">
//                                 Workspace
//                             </label>

//                             <input
//                                 type="radio"
//                                 className="btn-check"
//                                 name="filter-tabs"
//                                 id="all-tab"
//                                 autoComplete="off"
//                                 checked={selectedListType === "all"}
//                                 onChange={() => setSelectedListType("all")}
//                             />
//                             <label className="btn btn-outline-primary" htmlFor="all-tab">
//                                 All Locations
//                             </label>

//                             <input
//                                 type="radio"
//                                 className="btn-check"
//                                 name="filter-tabs"
//                                 id="selected-tab"
//                                 autoComplete="off"
//                                 checked={selectedListType === "selected"}
//                                 onChange={() => setSelectedListType("selected")}
//                             />
//                             <label className="btn btn-outline-primary" htmlFor="selected-tab">
//                                 All Selected
//                             </label>
//                         </div>

//                         {/* Apply button on the right */}
//                         <div>
//                             <button className="btn btn-primary" onClick={handleApply}>
//                                 Apply
//                             </button>
//                         </div>
//                     </div>

//                     {selectedListType === "all" && drillStack.length > 1 && (
//                         <div className="mb-2">
//                             <button className="btn btn-primary" onClick={goBackUp}>
//                                 Back
//                             </button>
//                             <span className="ms-2 fw-semibold">
//                                 {drillStack.map((d) => d.label).join(" > ")}
//                             </span>
//                         </div>
//                     )}

//                     <input
//                         type="text"
//                         placeholder="Search"
//                         className="form-control mb-3"
//                         value={searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                     />

//                     <ul className="list-group">
//                         {displayed.length === 0 ? (
//                             <li className="list-group-item text-muted">No locations</li>
//                         ) : (
//                             displayed.map((item, index) => {
//                                 const isSelected = selectedItems.some(
//                                     (sel) => sel.lgd_code === item.lgd_code
//                                 );
//                                 const isSelectedOnly = selectedListType === "selected";

//                                 const listItemStyle = {
//                                     backgroundColor: isSelected ? "#f2f2f2" : "inherit",
//                                     color: isSelected ? "#2d7be5" : "inherit",
//                                 };

//                                 return (
//                                     <li
//                                         key={index}
//                                         className="list-group-item d-flex justify-content-between align-items-center"
//                                         style={listItemStyle}
//                                     >
//                                         <span>
//                                             {index + 1}. {item.name}
//                                         </span>

//                                         <div className="d-flex align-items-center gap-2">
//                                             {selectedListType === "all" && item.geo_level < 4 && (
//                                                 <button
//                                                     className="btn btn-outline-primary"
//                                                     onClick={() => goDrillDown(item)}
//                                                 >
//                                                     {item.geo_level === 1 && "All States"}
//                                                     {item.geo_level === 2 && "All Districts"}
//                                                     {item.geo_level === 3 && "All ULBs"}
//                                                 </button>
//                                             )}

//                                             {!isSelectedOnly ? (
//                                                 <button
//                                                     onClick={() => addListOfItem(item)}
//                                                     className="btn btn-sm btn-outline-primary"
//                                                     disabled={isSelected}
//                                                 >
//                                                     +
//                                                 </button>
//                                             ) : (
//                                                 <button
//                                                     onClick={() => removeItem(item)}
//                                                     className="btn btn-sm btn-danger"
//                                                 >
//                                                     <FaTrashAlt />
//                                                 </button>
//                                             )}
//                                         </div>
//                                     </li>
//                                 );
//                             })
//                         )}
//                     </ul>
//                 </div>
//             </div>
//         )
//     );
// };

// export default StackedChart_FilterPopup;
import React, { useState, useEffect } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { MdInfoOutline } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// ============ HELPER FUNCTIONS ============
const getGeoLevelPlural = (geoLevel) => {
    switch (geoLevel) {
        case 1:
            return "States/UTs";
        case 2:
            return "Districts";
        case 3:
            return "ULGs";
        case 4:
            return "Wards";
        default:
            return "Locations";
    }
};

const getLocationLabel = (item, mainpayload) => {
    const matchingPayloadItem = mainpayload?.lgd_codes?.find(
        (p) => p.code === item.lgd_code && p.geo_level_code === item.geo_level
    );

    if (matchingPayloadItem?.type === "Children") {
        const nextLevelName = getGeoLevelPlural(item.geo_level);
        return `All ${nextLevelName} of ${item.name}`;
    }

    return item.name;
};

const getDrillDownButtonText = (geoLevel) => {
    const nextLevel = getGeoLevelPlural(geoLevel);
    return `Show All ${nextLevel}`;
};

const isChildrenType = (lgdCode, geoLevel, mainpayload) => {
    const match = mainpayload?.lgd_codes?.find(
        (p) => p.code === lgdCode && p.geo_level_code === geoLevel
    );
    // Return true ONLY if type is explicitly "Children"
    return match?.type === "Children";
};
// ==========================================

const StackedChart_FilterPopup = ({
    show,
    onClose,
    onApply,
    mainpayload,
    selectedItems,
    setSelectedItems,
    workspace_locations = [],
    fetchLocations,
}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedListType, setSelectedListType] = useState("workspace");
    const [drillStack, setDrillStack] = useState([
        { label: "India", value: 1000, geo_level: 1 },
    ]);
    const [currentList, setCurrentList] = useState([]);

    // Format main payload
    const mainFormattedPayload = (mainpayload?.lgd_codes || []).map((item) => ({
        name:
            item.code === 1000 && item.geo_level_code === 1
                ? "India"
                : item.name || `Code ${item.code}`,
        lgd_code: item.code,
        geo_level: item.geo_level_code,
    }));

    // Initial setup
    useEffect(() => {
        const hasIndia =
            mainpayload?.lgd_codes?.some(
                (p) => p.code === 1000 && p.geo_level_code === 1
            ) || false;

        setSelectedItems((prev) => {
            let updated = [...prev];
            if (hasIndia && !updated.some((p) => p.lgd_code === 1000)) {
                updated.push({ name: "India", lgd_code: 1000, geo_level: 1 });
            }

            mainFormattedPayload.forEach((item) => {
                if (!updated.some((p) => p.lgd_code === item.lgd_code)) {
                    updated.push(item);
                }
            });
            return updated;
        });
    }, [mainpayload]);

    // Fetch children
    useEffect(() => {
        const load = async () => {
            const top = drillStack[drillStack.length - 1];
            const parentCode = top.value ?? 1000;
            const nextLevel = top.geo_level;
            const children = await fetchLocations(parentCode, nextLevel);
            const mapped = (children || []).map((loc) => ({
                name: loc.name || loc.label,
                lgd_code: loc.code || loc.id || loc.value || loc.lgd_code || loc.properties?.code,
                geo_level: loc.geo_level || loc.geo_level_code || loc.properties?.geo_level || nextLevel,
            }));
            setCurrentList(mapped);
        };
        if (selectedListType === "all") load();
    }, [drillStack, selectedListType, fetchLocations]);

    const handleApply = () => {
        onApply(selectedItems, mainpayload);
        onClose();
    };

    const addListOfItem = (item, index) => {
        setSelectedItems((prev) => {
            const exists = prev.some((p) => p.lgd_code === item.lgd_code);
            if (!exists) {
                return [...prev, item];
            }
            return prev;
        });

        if (selectedListType === "all") {
            setCurrentList((prev) =>
                prev.map((obj, i) =>
                    i === index ? { ...obj, isDisabled: true } : obj
                )
            );
        }
    };

    const removeItem = (item) => {
        setSelectedItems((prev) =>
            prev.filter((p) => p.lgd_code !== item.lgd_code)
        );

        if (selectedListType === "all") {
            setCurrentList((prev) =>
                prev.map((obj) =>
                    obj.lgd_code === item.lgd_code
                        ? { ...obj, isDisabled: false }
                        : obj
                )
            );
        }
    };

    const getWorkspaceList = () => {
        // ✅ Always include India as the first item
        const indiaItem = {
            name: "India",
            lgd_code: 1000,
            geo_level: 1,
        };

        if (workspace_locations.length > 0) {
            const workspaceItems = workspace_locations.map((loc) => ({
                name: loc.name || loc.label,
                lgd_code: loc.code || loc.id || loc.value || loc.lgd_code || loc.properties?.code,
                geo_level: loc.geo_level || loc.geo_level_code || loc.properties?.geo_level,
            }));
            
            // Check if India already exists in workspace
            const hasIndia = workspaceItems.some(item => item.lgd_code === 1000 && item.geo_level === 1);
            
            return hasIndia ? workspaceItems : [indiaItem, ...workspaceItems];
        }
        
        // If no workspace locations, check mainFormattedPayload
        const mainItems = mainFormattedPayload.map((item) => ({ ...item, isDisabled: false }));
        const hasIndia = mainItems.some(item => item.lgd_code === 1000 && item.geo_level === 1);
        
        return hasIndia ? mainItems : [indiaItem, ...mainItems];
    };

    const getSelectedList = () => {
        const map = new Map();
        selectedItems.forEach((it) => {
            // Create a new object with the display label applied
            const itemWithLabel = {
                ...it,
                displayName: getLocationLabel(it, mainpayload), // Add display name
                name: it.name // Keep original name
            };
            map.set(it.lgd_code, itemWithLabel);
        });
        return Array.from(map.values());
    };

    const filterBySearch = (arr) =>
        arr.filter((x) =>
            x.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );

    const getDisplayed = () => {
        if (selectedListType === "workspace") return filterBySearch(getWorkspaceList());
        if (selectedListType === "all") return filterBySearch(currentList);
        if (selectedListType === "selected") return filterBySearch(getSelectedList());
        return [];
    };

    const displayed = getDisplayed();

    const goDrillDown = (loc) => {
        setDrillStack((prev) => [
            ...prev,
            { label: loc.name, value: loc.lgd_code, geo_level: loc.geo_level },
        ]);
    };

    const goBackUp = () => {
        if (drillStack.length > 1) setDrillStack((prev) => prev.slice(0, -1));
    };

    return (
        show && (
            <div
                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                style={{ background: "rgba(0,0,0,0.5)", zIndex: 1050 }}
            >
                <div
                    className="bg-white p-4 rounded shadow"
                    style={{
                        width: "600px",
                        maxHeight: "80vh",
                        overflowY: "auto",
                        position: "relative",
                    }}
                >
                    <button
                        className="btn-close position-absolute top-0 end-0 m-3"
                        onClick={onClose}
                    />

                    <h5 className="fw-bold mb-3 d-flex align-items-center gap-2">
                        Filters{" "}
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="filter-tooltip">
                                    <ol className="mb-0 ps-3">
                                        <li>Add with "+", remove in "All Selected" tab.</li>
                                        <li>"Show All Children" expands deeper levels.</li>
                                        <li>Items with type="Children" show aggregated label.</li>
                                    </ol>
                                </Tooltip>
                            }
                        >
                            <span>
                                <MdInfoOutline
                                    style={{ cursor: "pointer", color: "#000000" }}
                                />
                            </span>
                        </OverlayTrigger>
                    </h5>

                    <div className="d-flex justify-content-between align-items-center mb-3 w-100">
                        <div className="btn-group pt-2" role="group" aria-label="Filter tabs">
                            <input
                                type="radio"
                                className="btn-check"
                                name="filter-tabs"
                                id="workspace-tab"
                                autoComplete="off"
                                checked={selectedListType === "workspace"}
                                onChange={() => setSelectedListType("workspace")}
                            />
                            <label className="btn btn-outline-primary" htmlFor="workspace-tab">
                                Workspace
                            </label>

                            <input
                                type="radio"
                                className="btn-check"
                                name="filter-tabs"
                                id="all-tab"
                                autoComplete="off"
                                checked={selectedListType === "all"}
                                onChange={() => setSelectedListType("all")}
                            />
                            <label className="btn btn-outline-primary" htmlFor="all-tab">
                                All Locations
                            </label>

                            <input
                                type="radio"
                                className="btn-check"
                                name="filter-tabs"
                                id="selected-tab"
                                autoComplete="off"
                                checked={selectedListType === "selected"}
                                onChange={() => setSelectedListType("selected")}
                            />
                            <label className="btn btn-outline-primary" htmlFor="selected-tab">
                                All Selected
                            </label>
                        </div>

                        <div>
                            <button className="btn btn-primary" onClick={handleApply}>
                                Apply
                            </button>
                        </div>
                    </div>

                    {selectedListType === "all" && drillStack.length > 1 && (
                        <div className="mb-2">
                            <button className="btn btn-primary" onClick={goBackUp}>
                                Back
                            </button>
                            <span className="ms-2 fw-semibold">
                                {drillStack.map((d) => d.label).join(" > ")}
                            </span>
                        </div>
                    )}

                    <input
                        type="text"
                        placeholder="Search"
                        className="form-control mb-3"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />

                    <ul className="list-group">
                        {displayed.length === 0 ? (
                            <li className="list-group-item text-muted">No locations</li>
                        ) : (
                            displayed.map((item, index) => {
                                const isSelected = selectedItems.some(
                                    (sel) => sel.lgd_code === item.lgd_code
                                );
                                const isSelectedOnly = selectedListType === "selected";
                                
                                // Use helper to get label only in "All Selected" tab
                                const displayLabel = selectedListType === "selected" 
                                    ? (item.displayName || getLocationLabel(item, mainpayload))
                                    : item.name;
                                const hasChildren = isChildrenType(item.lgd_code, item.geo_level, mainpayload);

                                return (
                                    <li
                                        key={index}
                                        className={`list-group-item d-flex justify-content-between align-items-center ${
                                            hasChildren ? 'bg-light border-primary' : ''
                                        }`}
                                        style={{ backgroundColor: hasChildren ? '#f6f7f8' : '' }}
                                    >
                                        <span>
                                            {index + 1}. {displayLabel}
                                        </span>

                                        <div className="d-flex align-items-center gap-2">
                                            {selectedListType === "all" &&
                                                item.geo_level < 4 && (
                                                    <button
                                                        className="btn btn-sm btn-outline-primary"
                                                        onClick={() => goDrillDown(item)}
                                                    >
                                                        {getDrillDownButtonText(item.geo_level)}
                                                    </button>
                                                )}

                                            {!isSelectedOnly ? (
                                                <button
                                                    onClick={() => addListOfItem(item, index)}
                                                    className="btn btn-sm btn-outline-primary"
                                                    disabled={isSelected}
                                                >
                                                    +
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => removeItem(item)}
                                                    className="btn btn-sm btn-danger"
                                                >
                                                    <FaTrashAlt />
                                                </button>
                                            )}
                                        </div>
                                    </li>
                                );
                            })
                        )}
                    </ul>
                </div>
            </div>
        )
    );
};

export default StackedChart_FilterPopup;